import { render, staticRenderFns } from "./PatientVisit.vue?vue&type=template&id=cc896e92&scoped=true"
import script from "./PatientVisit.vue?vue&type=script&lang=ts"
export * from "./PatientVisit.vue?vue&type=script&lang=ts"
import style0 from "./PatientVisit.vue?vue&type=style&index=0&id=cc896e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc896e92",
  null
  
)

export default component.exports